import { useEffect, useRef } from 'react'
import 'react-quill/dist/quill.snow.css'

// @ts-ignore - ReactQuill type incompatibility with React 18
import ReactQuill from 'react-quill'

interface RichTextEditorProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

export default function RichTextEditor({ value, onChange, placeholder, className }: RichTextEditorProps) {
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image', 'video'],
      ['blockquote', 'code-block'],
      [{ 'align': [] }],
      ['clean']
    ]
  }

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
    'blockquote', 'code-block',
    'align'
  ]

  // Cast to any to avoid TypeScript errors with React 18
  const QuillComponent = ReactQuill as any

  return (
    <div className={className}>
      <QuillComponent
        theme="snow"
        value={value}
        onChange={(content: string) => {
          // Ensure content is HTML by wrapping text content in appropriate tags
          if (content && !content.includes('<p>') && !content.includes('<h1>') && !content.includes('<ul>')) {
            // If content looks like plain text, convert to paragraph HTML
            const paragraphs = content.split('\n').filter(line => line.trim());
            const htmlContent = paragraphs.map(p => `<p>${p.trim()}</p>`).join('');
            onChange(htmlContent);
          } else {
            onChange(content);
          }
        }}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        className="bg-white"
      />
    </div>
  )
}
